import { Button, Grid } from "@material-ui/core";
import { ChevronRight, Pageview } from "@material-ui/icons";
import { LatLngExpression } from "leaflet";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import { useNavigate } from "react-router-dom";
import { useConfig } from "../../../helpers/use-config";
import { IParkingLotsMapProps, MapConfig } from "./props";
import "./vjts-map.scss";

// Based on the following tutorial: https://blog.logrocket.com/react-leaflet-tutorial/
// eslint-disable-next-line @typescript-eslint/naming-convention
export function VjtsMap(props: IParkingLotsMapProps)
{

    const config = useConfig();
    const isMapDataPresent = props.data && props.data.length > 0;
    const navigate = useNavigate();

    if (!config) return <div>Loading map...</div>;
    return (
        <MapContainer center={config.center} zoom={config.zoom} scrollWheelZoom>
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {isMapDataPresent ? props.data.map((elem, i) => (
                <Marker position={elem.latLongData as LatLngExpression} key={i}>
                    <Popup>
                        <Grid container spacing={1}>
                            <Grid item xs={12} className="marker-popup-title">
                                {elem.name}
                            </Grid>
                            <Grid item xs={12}>
                                <Button
                                    variant="contained"
                                    startIcon={<Pageview />}
                                    color="primary"
                                    endIcon={<ChevronRight />}
                                    onClick={() =>
                                    {
                                        navigate("/kijelzok/", { state: { megnevezes: elem.name } });
                                    }}
                                >
                                    Tovább
                                </Button>
                            </Grid>
                        </Grid>
                    </Popup>
                </Marker>
            )) : undefined}
        </MapContainer>
    );
}
